import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'

export const nonCumulativeColDefs = createColDefs([
  {
    field: 'value_date',
    rowGroup: true,
    hide: true,
  },
  {
    field: 'instrument_type',
    headerName: 'Instrument Type',
  },
  {
    field: 'fund_name',
    headerName: 'Fund',
  },
  {
    field: 'unique_identifier',
    headerName: 'Instrument',
  },
  {
    field: 'under_short_name',
    headerName: 'Underlyings',
  },
  {
    field: 'top_level_bucket',
    headerName: 'Top Level Bucket',
  },
  {
    field: 'investment_bucket',
    headerName: 'Investment Bucket',
  },
  {
    field: 'nav',
    headerName: 'Nav (T)',
    width: 115,
    valueFormatter: numberFormatter({
      delimiter: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  },
  {
    field: 'nav_tmo',
    headerName: 'Nav (T-1)',
    width: 115,
    valueFormatter: numberFormatter({
      delimiter: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  },
  {
    field: 'pnl',
    headerName: 'PNL',
    width: 115,
    valueFormatter: numberFormatter({
      delimiter: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  },
  {
    field: 'pnl_over_nav_bps',
    headerName: 'Attribution (bps)',
    width: 150,
    valueFormatter: numberFormatter({
      delimiter: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  },
])

export const cumulativeColDefs = createColDefs([
  {
    field: 'fund_name',
    headerName: 'Fund',
  },
  {
    field: 'instrument_type',
    headerName: 'Instrument Type',
  },
  {
    field: 'unique_identifier',
    headerName: 'Instrument',
  },
  {
    field: 'under_short_name',
    headerName: 'Underlyings',
  },
  {
    field: 'top_level_bucket',
    headerName: 'Top Level Bucket',
  },
  {
    field: 'investment_bucket',
    headerName: 'Investment Bucket',
  },
  {
    field: 'performance_cumulative_bps',
    headerName: 'Cumulative Attribution (bps)',
    valueFormatter: numberFormatter({
      delimiter: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }),
  },
])
